export default __webpack_public_path__ + "static/media/StoreReturnDisable.602ae839.svg";